<template>
  <div class="ResetPassword">
    <div class="head">
      <van-icon name="arrow-left" class="black_arrow" @click="$router.replace('/verification')"/>
      <div class="title">设置新密码</div>
    </div>
    <div class="EditingArea vanField">
      <ul>
        <li class="passwordInputWrapper">
          <van-field
            v-model="password"
            class="passwordStyle fl"
            clearable
            :type="isVisible"
            @focus="inputFocus"
            placeholder="设置8到20位登录密码"
            :border="false"
          />

          <div class="VisibleCutApart fl"></div>

          <div class="Visible fr" @click="setVisible('password')">
            <img class="fl" :src="isVisibleImg" alt="" />
          </div>

          <div class="clear"></div>
        </li>
        <li class="passwordInputWrapper">
          <van-field
            v-model="rePassword"
            class="passwordStyle fl"
            clearable
            :type="isVisible2"
            @focus="inputFocus"
            @blur="inputBlur"
            placeholder="请输入登录密码"
            :border="false"
          />

          <div class="VisibleCutApart fl"></div>

          <div class="Visible fr" @click="setVisible('rePassword')">
            <img class="fl" :src="isVisibleImg2" alt="" />
          </div>

          <div class="clear"></div>
        </li>
      </ul>
    </div>
    <div class="OperatingSpace">
      <van-button
        round type="info"
        @click="confirmReset"
        :class="this.password ? 'van-button--info' : 'noneVanButton'"
      >确认</van-button>
    </div>
  </div>
</template>

<script>
import yincang from '../../../assets/images/account/icon-yincang.png'
import xianshi from '../../../assets/images/account/icon-xianshi.png'
import { passReg } from '../../../utils/validate'
export default {
  name: 'resetPassword',
  data () {
    return {
      password: null,
      rePassword:null,
      isVisible: 'password',
      isVisible2:'password',
      clientHeight: 0
    }
  },
  computed: {
    isVisibleImg () {
      return this.isVisible === 'password' ? yincang : xianshi
    },
    isVisibleImg2(){
      return this.isVisible2 === 'password' ? yincang : xianshi
    }
  },
  created () {
    window.addEventListener('resize', this.inputFocus)
  },
  mounted(){
    
  },
  destroyed () {
    window.removeEventListener('resize', this.inputFocus)
  },
  methods: {
    inputBlur(){
      let result = true
      if(!this.password || !this.rePassword){
        result = false
      }
      if((this.password && this.rePassword) && (this.password !== this.rePassword)){
        this.$notify({ type: 'warning', message: '两次密码输入不一致，请重新输入' })
        result = false
      }
      return result
    },
    confirmReset(){
      let account = this.$route.query.a
      let authCode = this.$route.query.b
      let password = this.password
      let data = {account,authCode,password}
      if(!passReg.test(password)){
        this.$notify({ type: 'warning', message: '请设置8-20位，数字、大小写字母、字符组合密码' })
        return
      }
      if(!this.inputBlur()) return
      this.$api.usercenter.resetPassword({ data }).then(res => {
          if(res.data){
            this.$toast({
                message:'密码重置成功！请妥善保管账户信息',
                className:'success'
            })
            this.toRouter('/login')
          }
        });
    },
    toRouter (path) {
      this.$router.push({ path })
    },
    setVisible (type) {
        if(type === 'rePassword'){
            console.log('isVisible2',this.isVisible2)
            if (this.isVisible2 === 'password') {
                this.isVisible2 = 'text'
                return false
            }
            this.isVisible2 = 'password'
        }else {
            if (this.isVisible === 'password') {
                this.isVisible = 'text'
                return false
            }
            this.isVisible = 'password'
        }
      
    },
    inputFocus () {
      const height = document.documentElement.clientHeight
      if (this.clientHeight > height) {
        let vanField = document.querySelectorAll('.vanField')
        let total = vanField[0].offsetTop - 20
        document.body.scrollTop = total
      } else {
        document.body.scrollTop = 0
      }
      this.clientHeight = document.documentElement.clientHeight
    },
  }
}
</script>

<style scoped lang='stylus'>
.head {
  position:relative;
  width: 100%;
  height: 100px;
  background: #ffffff;
  text-align: center;
}
.title {
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 100px;
}
.black_arrow {
  position: absolute;
  left: 30px;
  top: 50%;
  transform:translateY(-50%);
}
.ResetPassword{
  background-color #FFFFFF
  min-height 100vh
}
.EditingArea{
  width 622px
  padding-top 32px
  position relative
  margin-left -311px
  left 50%
  li {
    padding 2px 0
    height 122px
    overflow hidden
    border-bottom 1px solid #D7D7D7
    .passwordStyle{
      width 548px
      display inline-block
    }
    .VisibleCutApart{
      margin 0 24px
      width  2px
      height 32px
      border-radius 1px
      background-color #D7D7D7
    }
    .Visible{
      display inline-block
      img{
        width 48px
      }
    }
  }
  li.passwordInputWrapper{
    display flex
    align-items center
  }
  .van-cell{
    padding 0
    height 58px
    line-height 58px
    font-size 18px
    background transparent
  }
}
.OperatingSpace{
  width 622px
  position relative
  margin-left -311px
  left 50%
  .van-button{
    width 100%
    height 44px
    line-height 44px
    margin-top 32px
    margin-bottom 24px
    span{
      color #FFFFFF
      font-size 16px
    }
  }
  .noneVanButton{
    background-color #C0D5FF
    border 1px solid #C0D5FF
  }
  .van-button--info{
    background-color linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
    border 1px solid linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
  }
}
</style>